import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import PageBase from 'components/common/PageBase';
import DetailsPage from 'containers/detailsPage/DetailsPage';

class DENTPageDetails extends Component {
    render() {
        const { translate} = this.props;
        return (
            <PageBase title={translate('DentDetailsForm.title')} showGoToButtons={true} showDownloadButtons={true} id={this.props.params.id} isIcnPlus={true} isDent={true}  >
                <DetailsPage id={this.props.params.id} isIcnPlus={true} isDent={true} />
            </PageBase>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    };
}

export default connect(mapStateToProps)(DENTPageDetails);


// WEBPACK FOOTER //
// ./src/pages/dent/DENTPageDetails.js